import React from 'react';
import { motion } from "framer-motion";
import ServicesCard from './ServicesCard';
import ServiceDetails from './ServiceDetails';
import { useNavigate, useParams } from 'react-router-dom';
import { FaArrowCircleRight } from "react-icons/fa";


const Services = ({ serviceDetails }) => {
  const parsePrice = (price) => {
  if (!price) return 0;

  return Number(
    String(price).replace(/[^\d.]/g, "")
  );
};


  console.log(serviceDetails)
  const { serviceId } = useParams();
  const navigate = useNavigate();

  if (serviceId) {
    const service = serviceDetails.find((service) => service.id === serviceId);
    if (service) {
      return <ServiceDetails service={service} />;
    }
  }

  return (
    <div className="min-h-screen py-16 md:py-24 lg:py-32 relative overflow-hidden bg-gradient-to-b from-[#f0f7f3] to-white">
      {/* Animated background elements */}
      <motion.div
        animate={{ x: [0, 50, 0], y: [0, 30, 0] }}
        transition={{ duration: 20, repeat: Infinity, ease: "easeInOut" }}
        className="absolute -top-32 -left-32 w-64 h-64 rounded-full bg-[#0e4322]/10 blur-3xl"
      ></motion.div>
      <motion.div
        animate={{ x: [0, -50, 0], y: [0, -30, 0] }}
        transition={{ duration: 25, repeat: Infinity, ease: "easeInOut" }}
        className="absolute -bottom-32 -right-32 w-64 h-64 rounded-full bg-[#3a5630]/10 blur-3xl"
      ></motion.div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-block mb-6"
          >
            <span className="bg-[#0e4322] text-white text-sm font-semibold px-4 py-2 rounded-full">
              PROFESSIONAL SOLUTIONS
            </span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-center text-[#0F172A] mb-6"
          >
            Transform Your <span className="text-[#0e4322]">Financial Future</span> With Our Experience
          </motion.h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="text-xl md:text-2xl text-[#1F2937] text-center max-w-3xl mx-auto mb-8"
          >
            Join <span className="font-semibold text-[#0e4322]"> the Queue of Satisfied Client </span> who've achieved their financial goals with our proven strategies
          </motion.p>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3, duration: 0.5 }}
            className="flex flex-col sm:flex-row justify-center gap-4"
          >
            <button
              className="px-10 py-4 bg-gradient-to-br from-green-700 via-green-600 to-green-700 text-white rounded-xl font-bold hover:shadow-xl transition-all duration-300 hover:scale-[1.03] shadow-lg relative overflow-hidden group"
              onClick={() => navigate("/contactus")}
            >
              <span className="absolute inset-0 bg-gradient-to-r from-green-900 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></span>
              <span className="relative z-10 flex items-center justify-center gap-2">
                Get Started Today
                <FaArrowCircleRight />
              </span>
            </button>

          </motion.div>
        </div>

        {/* Services Grid */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.6 }}
        >
          <h2 className="text-3xl font-bold text-center mb-12">
            Our <span className="text-[#0e4322]">Premium Services</span>
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {serviceDetails.map((service, i) => (
              <motion.div
                key={i}
                whileHover={{ y: -10, boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)" }}
                transition={{ duration: 0.3 }}
              >
                <ServicesCard
                  heading={service.heading}
                  description={service.description}
                  serviceId={service.id}
                  icon={service.icon}
                  popular={service.popular}
                />
              </motion.div>
            ))}
          </div>
        </motion.div>


        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 0.6 }}
          className="bg-gradient-to-r from-[#0e4322] to-[#3a5630] rounded-2xl p-8 md:p-12 text-white text-center"
        >
          <h3 className="text-2xl md:text-3xl font-bold mb-4">Ready to Achieve Your Financial Goals?</h3>
          <p className="text-lg mb-8 max-w-2xl mx-auto">
            Our professionals are standing by to create a customized strategy just for you. Schedule your free consultation today.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button
              className="px-8 py-4 bg-white text-[#0e4322] rounded-xl font-bold hover:bg-gray-100 transition-all duration-300 shadow-md"
              onClick={() => navigate("/contactus")}
            >
              Book Free Consultation
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Services;